export const getStyled = (theme) => ({
  dialog: {
    '& .MuiDialogPaper': {
      width: '400px',
      maxWidth: '400px',
      borderRadius: 12,
    },
  },
  dialogTitle: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '16px 16px 8px 16px',
    '& h6': {
      fontSize: '1.1rem',
      fontWeight: 600,
    },
  },
  closeButton: {
    padding: 4,
  },
  content: {
    padding: '8px 16px 16px 16px',
  },
  listItem: {
    padding: '3px 16px',
    borderRadius: 8,
    '&:hover': {
      backgroundColor: theme.palette.action.hover,
      '& $deleteButton': {
        opacity: 1,
      },
    },
  },
  reactionEmoji: {
    fontSize: '22px',
    margin: '0 15px',
    minWidth: 32,
    display: 'flex',
    justifyContent: 'center',
    transform: 'translateY(-10%)',
  },
  contactName: {
    fontSize: '0.95rem',
    fontWeight: 500,
  },
  reactionTime: {
    fontSize: '0.75rem',
  },
  deleteButton: {
    transition: 'opacity 0.2s',
    padding: 4,
    '&:hover': {
      color: '#fff',
    },
  },
  fromMeTag: {
    fontSize: '0.7rem',
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    padding: '2px 6px',
    borderRadius: 10,
    marginLeft: 15,
  },
  avatar: {
    width: 32,
    height: 32,
    fontSize: '0.9rem',
  },
});
